var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcNotificationReceived(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-472 -503) translate(0 492) translate(456) translate(16 12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#F79000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M13.029 13.098c0-.299.08-.553.238-.763.159-.21.41-.469.756-.777.29-.261.525-.492.707-.693.182-.2.336-.446.462-.735.126-.29.189-.625.189-1.008 0-.812-.324-1.447-.973-1.904-.649-.457-1.51-.686-2.583-.686-.915 0-1.706.163-2.373.49-.667.327-1.197.789-1.589 1.386l1.694.994c.233-.327.52-.581.861-.763.34-.182.73-.273 1.169-.273.457 0 .824.1 1.099.301.275.2.413.474.413.819 0 .243-.072.46-.217.651-.145.191-.371.427-.679.707-.42.383-.74.733-.959 1.05-.22.317-.329.719-.329 1.204h2.114zm-1.05 3.514c.383 0 .702-.124.959-.371s.385-.548.385-.903-.126-.651-.378-.889-.574-.357-.966-.357-.714.119-.966.357-.378.534-.378.889.128.656.385.903.576.371.959.371z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotificationReceived);
export default __webpack_public_path__ + "static/media/ic-notification-received.77c5774ee0d2bcfc1331896f91ced14c.svg";
export { ForwardRef as ReactComponent };